'use client';

import { useEffect, useState } from 'react';
import { HighlightInit } from '@highlight-run/next/client';
import { isNative } from '@/lib/platform';

export function HighlightWithConsent() {
  const [hasConsent, setHasConsent] = useState(false);
  const [mounted, setMounted] = useState(false);

   
  useEffect(() => {
    setMounted(true);

    // Skip Highlight.io in development to improve performance
    if (process.env.NODE_ENV === 'development') {
      setHasConsent(false);
      return;
    }

    // Skip on native — Highlight.io's Cloudflare Worker integration isn't
    // in the request path, so server-side correlation won't work.
    if (isNative()) {
      setHasConsent(false);
      return;
    }

    // Suppress Highlight.io errors to prevent Best Practices issues
    // Intercept console.error to filter Highlight-related quota errors
    const originalError = console.error;
    console.error = (...args: unknown[]) => {
      const message = args.join(' ');
      // Suppress Highlight.io billing quota errors
      if (message.includes('BillingQuotaExceeded') || message.includes('eO:')) {
        return; // Silently ignore
      }
      originalError.apply(console, args);
    };

    // For now, enable by default (Zaraz consent will be added later)
    // TODO: Integrate with Cloudflare Zaraz when configured
    setHasConsent(true);

    // Check Cloudflare Zaraz consent (optional - requires Zaraz setup)
    const checkConsent = () => {
      // @ts-ignore - Zaraz types not available
      if (typeof window !== 'undefined' && window.zaraz?.consent) {
        // @ts-ignore
        const analyticsConsent = window.zaraz.consent?.get?.('analytics');

        if (analyticsConsent === false) {
          // Explicitly denied
          setHasConsent(false);
        }
      }
    };

    // Check on mount and listen for changes
    checkConsent();

    // Listen for consent changes
    if (typeof window !== 'undefined') {
      // @ts-ignore
      window.addEventListener('zarazConsentChoicesUpdated', () => {
        checkConsent();
      });
    }

    return () => {
      // Restore original console.error on unmount
      console.error = originalError;
    };
  }, []);
   

  if (!mounted || !hasConsent) {
    return null;
  }

  return (
    <HighlightInit
      projectId="7e3y9mqg"
      serviceName="theartofcto-frontend"
      tracingOrigins
      networkRecording={{
        enabled: true,
        recordHeadersAndBody: true,
        urlBlocklist: [],
      }}
      storageMode="localStorage"
    />
  );
}
